module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[107]594.80709f1.woff2";